import { StatusPresentationLoadingState } from '@/features/shared/components/StatusPresentationLoadingState';
import type { ReactElement } from 'react';

export const ExecutionRunsPageLoadingState = (): ReactElement => (
  <StatusPresentationLoadingState message="Loading execution runs..." />
);
